/* eslint-disable */
import React, { useState, useEffect } from "react";
import "./style.css";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as Close } from "../../assets/images/teamclose.svg";
import { ReactComponent as AccountTypeIcon } from "../../assets/images/accountlogo.svg";
import { ReactComponent as AccountChat } from "../../assets/images/accountchat.svg";
import { ReactComponent as AccountLogin } from "../../assets/images/groupthumb.svg";
import { ReactComponent as AccountSeen } from "../../assets/images/accountseen.svg";
import Supervisor from "./Supervisor";
import Avatar from "@mui/material/Avatar";
import Skeleton from "@mui/material/Skeleton";
import GroupAssignChat from "./GroupAssignChat";
import { ListGroupIndiApi } from "../../store/features/ListGroupIndividual";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setActiveGroupSideBar } from "../../Redux/group";

const TeamSideBarSection = [0, 1, 2, 3, 4];

function GroupSideBar(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [showAllMembers, setShowAllMembers] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const chracterPosition = (alphabet) => {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
    return positionOfAlphabet;
  };

  const colorCodesForAvatar = [
    "#405261", "#FF4D4F", "#FA541C", "#FA8C16", "#FAAD14",
    "#EB2F96", "#FADB14", "#A0D911", "#52C41A", "#5CDBD3",
    "#9254DE", "#F759AB", "#2F54EB", "#722ED1", "#1890FF",
    "#13C2C2", "#2DB7F5", "#19BE6B", "#30A745", "#FA8C16",
    "#FAAD14", "#9254DE", "#F759AB", "#13C2C2", "#722ED1", "#2DB7F5",
  ];

  const { activeGroupSideBar, getGroupUserList } = props;
  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const t = useSelector((state) => state.language.translations[currentLanguage]);

  const getGroupList = async () => {
    const outputarray = [];
    const listCoUserList = dispatch(
      ListGroupIndiApi({
        id: getGroupUserList.id,
      })
    );
    listCoUserList
      .then(async (data) => {
        if (data?.payload?.status === 200) {
          const item = data?.payload?.data;
          console.log('item', item)
          outputarray.push({
            id: item?.group._id,
            img: item?.group?.group_image,
            name: item?.group?.title,
          });
          setData(outputarray);
        } else {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            theme: "light",
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error.message || "Something went wrong.", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
      });
  };
  const group = getGroupUserList; // D
  useEffect(() => {
    getGroupList();
  }, []);

  // -------------------
  // 🩶 Skeleton Layout
  // -------------------
  const renderSkeleton = () => (
    <div className="Team-Main-SideBar--skeleton">
      <div className="Team-SideBar">
        <Skeleton variant="text" width={80} height={24} sx={{ bgcolor: "#E0E0E0" }} />
        <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: "#E0E0E0" }} />
      </div>

      {[1, 2].map((i) => (
        <div key={i} className="Team-sidebar-profile-group">
          <div className="Team-logo-profile-group">
            <Skeleton variant="circular" width={40} height={40} sx={{ bgcolor: "#E0E0E0" }} />
            <div className="team-profile-text">
              <Skeleton variant="text" width={120} height={20} sx={{ bgcolor: "#E0E0E0" }} />
              <Skeleton variant="text" width={80} height={16} sx={{ bgcolor: "#E0E0E0" }} />
            </div>
          </div>
          <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: "8px", bgcolor: "#E0E0E0" }} />
        </div>
      ))}

      <p className="profile-linestyle" />

      <div className="GroupSide-Content-Container">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="AccountType-content" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
            <div className="Account-Type01" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: "#E0E0E0" }} />
              <Skeleton variant="text" width={120} height={20} sx={{ bgcolor: "#E0E0E0" }} />
            </div>
            <Skeleton variant="text" width={40} height={20} sx={{ bgcolor: "#E0E0E0" }} />
          </div>
        ))}

        <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: "12px", bgcolor: "#E0E0E0", marginTop: "16px" }} />
        <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: "12px", bgcolor: "#E0E0E0", marginTop: "16px" }} />
      </div>
    </div>
  );

  const members = Array.isArray(getGroupUserList?.user) ? getGroupUserList.user : [];
  const displayedMembers = showAllMembers ? members : members.slice(0, 4);
  const showToggleButton = members.length > 4;

  return (
    <div
      className={`Team-Main-SideBar ${activeGroupSideBar
        ? "Team-Main-SideBar--open"
        : "Team-Main-SideBar--closed"
        }`}
    >
      {isLoading ? (
        renderSkeleton()
      ) : (
        <>
          <div className="Team-SideBar">
            <p className="detail-text">{t.Details}</p>
            <p
              className="TeamClose-btn"
              onClick={() => dispatch(setActiveGroupSideBar(false))}
            >
              <Close />
            </p>
          </div>

          <div key={group.id} className="Team-sidebar-profile-group">
            <div className="Team-logo-profile-group">
              <p>
                {group.img ? (
                  <Avatar
                    src={group.img}
                    alt="users logo"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor:
                        colorCodesForAvatar[
                        chracterPosition(
                          group?.name?.substring(0, 1).toUpperCase()
                        )
                        ],
                    }}
                  >
                    {group?.name?.substring(0, 1).toUpperCase()}
                  </Avatar>
                )}
              </p>
              <div className="team-profile-text">
                <p className="Robert-Fox">{group.name}</p>
                <p className="Nathan-Fox">{getGroupUserList.member}</p>
              </div>
            </div>
            <button style={{ cursor: 'default' }} className="agent-button">Group</button>
          </div>

          <p className="profile-linestyle" />
          <div className="GroupSide-Content-Container">
            <div className="AccountType-Main-Container01">
              <div className="AccountType-content">
                <div className="Account-Type01">
                  <AccountTypeIcon />
                  <p className="AccountType-text">Total Chats:</p>
                </div>
                <p className="AccountAgent-text">25</p>
              </div>
              <div className="AccountType-content">
                <div className="Account-Type01">
                  <AccountChat />
                  <p className="AccountType-text">Available Agents:</p>
                </div>
                <p className="AccountAgent-text">12</p>
              </div>
              <div className="AccountType-content">
                <div className="Account-Type01">
                  <AccountLogin />
                  <p className="AccountType-text">Chat satisfaction:</p>
                </div>
                <p className="AccountAgent-text">100%</p>
              </div>
              <div className="AccountType-content">
                <div className="Account-Type01">
                  <AccountSeen />
                  <p className="AccountType-text">Last Seen:</p>
                </div>
                <p className="AccountAgent-text">Just Now</p>
              </div>
            </div>
            {/* <div className="SuperVisor-Container">
              <Supervisor />
            </div> */}


            {/* Render each team member */}
            <div className="TeamAssign-Container">
              <div style={{ paddingTop: '24px', paddingBottom: '0px', paddingLeft: '0px', paddingRight: '0px' }} className="AssignChat-Main-Container">
                <div style={{ marginBottom: '14px', padding: '0px 24px' }} className="AssignChat-Header">
                  <p className="AssignChat-text">Members</p>
                  {showToggleButton && (
                    <p
                      className="AssignChat-View"
                      style={{ cursor: 'pointer', textDecoration: 'underline' }}
                      onClick={() => setShowAllMembers(prev => !prev)}
                    >
                      {showAllMembers ? 'View Less Members' : 'View All Members'}
                    </p>
                  )}
                </div>

                {displayedMembers.length > 0 ? (
                  displayedMembers.map((user, index) => {
                    const src = user?.props?.src;
                    const name = user?.props?.alt;
                    const email = user?.props?.email;
                    const firstLetter = user?.props?.children;
                    const bgColor = user?.props?.sx?.bgcolor;

                    return (
                      <div
                        key={index}
                        className="MemberRow"
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          {src ? (
                            <Avatar src={src} alt={name} sx={{ width: 40, height: 40, marginLeft: '16px' }} />
                          ) : (
                            <Avatar
                              sx={{
                                bgcolor: bgColor,
                                width: 40,
                                height: 40,
                                fontSize: "16px",
                                color: "#fff",
                                fontWeight: 500,
                                marginLeft: '16px'
                              }}
                            >
                              {firstLetter}
                            </Avatar>
                          )}

                          <div>
                            <p className="member-title">
                              {name}
                            </p>
                            <p className="member-email">
                              {email}
                            </p>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "13px",
                            color: "#111827",
                          }}
                        >
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div style={{ padding: "16px", textAlign: "center", color: "#6B7280" }}>
                    No users found
                  </div>
                )}
              </div>
            </div>


          </div>
        </>
      )}
    </div>
  );
}

export default GroupSideBar;